"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgPrimaryPay = function SvgPrimaryPay(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1044 297",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#prefix__clip0)",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M18.267 239.308L25.348 297h247.91l-8.113-66.071H149.558l-1.01-8.187 106.464-74.396-7.113-57.81H0l8.113 66.071H123.89l1.021 8.262-106.645 74.439z",
        fill: "#1A0826"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M277.319 90.536L302.667 297h480.689L757.997 90.536H277.319z",
        fill: "#AA8FFF"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M1042.92 164.922c-5.72-46.4-42.18-74.534-91.728-74.332H786.174l25.348 206.463h74.237l-5.083-41.297h78.564c61.84-.053 90.13-38.585 83.68-90.834zm-91.697 32.961l-77.618.085-6.071-49.548 78.044.064c18.362.213 27.751 10.558 29.26 24.7.947 9.037-3.232 24.635-23.615 24.635v.064zM338.221 70.843c13.057-14.018 10.781-37.362-5.084-52.14-15.865-14.779-39.311-15.396-52.369-1.378-13.057 14.018-10.781 37.361 5.084 52.14 15.865 14.778 39.311 15.395 52.369 1.378zM387.728 226.251l3.434 28.07h-42.137l-14.386-117.044h69.442c48.644 0 70.175 15.184 73.95 45.54 3.562 29.048-16.183 43.593-61.414 43.391l-28.889.043zm-6.975-56.789l3.19 26.273h27.485c18.809 0 24.742-3.264 23.572-12.759-1.382-11.26-9.25-13.546-27.336-13.546l-26.911.032zM572.384 234.268h-50.388l-5.667 20.074h-40.404l37.48-116.958h43.849l65.858 116.958h-40.021l-10.707-20.074zm-32.961-61.85l-9.686 34.109h27.9l-18.214-34.109zM648.449 254.342l-5.709-46.496-57.469-70.505h44.38l30.186 38.352 21.935-38.352h44.221l-42.605 70.664 5.689 46.348-40.628-.011z",
        fill: "#1A0826"
      })]
    }), (0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("clipPath", {
        id: "prefix__clip0",
        children: (0, _jsxRuntime.jsx)("path", {
          fill: "#fff",
          d: "M0 0h1043.82v297H0z"
        })
      })
    })]
  }));
};

var _default = SvgPrimaryPay;
exports["default"] = _default;